var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEllipsis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "6px",
    viewBox: "0 0 22 6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "more copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDFE0-Home-&-Menus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "D_Home_Hamburger_Not-LoggedIN",
    transform: "translate(-37.000000, -505.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "more-copy",
    transform: "translate(37.721977, 505.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.98678414,6 C4.63552511,6 5.97356828,4.65610107 5.97356828,3 C5.97356828,1.34389893 4.63558961,0 2.98678414,0 C1.33797867,0 0,1.34389893 0,3 C0,4.65610107 1.33797867,6 2.98678414,6 Z M2.98678414,1.20056151 C3.97198643,1.20056151 4.77829558,2.01043841 4.77829558,3 C4.77829558,3.98956159 3.97198643,4.79943849 2.98678414,4.79943849 C2.00158186,4.79943849 1.19527204,3.98956159 1.19527204,3 C1.19443263,2.01043841 2.00074329,1.20056151 2.98678414,1.20056151 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3010279,3 C7.3010279,4.65603628 8.63900657,6 10.287812,6 C11.9366175,6 13.2745962,4.65610107 13.2745962,3 C13.2745962,1.34389893 11.9366175,0 10.287812,0 C8.63900657,0 7.3010279,1.34389893 7.3010279,3 Z M12.0793235,3 C12.0793235,3.98956159 11.2730143,4.79943849 10.287812,4.79943849 C9.30260976,4.79943849 8.4963006,3.98956159 8.4963006,3 C8.4963006,2.01043841 9.30260976,1.20056151 10.287812,1.20056151 C11.2730143,1.20056151 12.0793235,2.01043841 12.0793235,3 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5888399,0 C15.940099,0 14.6020558,1.34389893 14.6020558,3 C14.6020558,4.65610107 15.9400345,6 17.5888399,6 C19.2376454,6 20.5756241,4.65610107 20.5756241,3 C20.5756241,1.34389893 19.2376454,0 17.5888399,0 Z M17.5888399,4.79943849 C16.6036377,4.79943849 15.7973285,3.98956159 15.7973285,3 C15.7973285,2.01043841 16.6036377,1.20056151 17.5888399,1.20056151 C18.5740422,1.20056151 19.380352,2.01043841 19.380352,3 C19.3811915,3.98956159 18.5748808,4.79943849 17.5888399,4.79943849 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default ForwardRef;